import React from 'react';
import { useTranslation } from 'react-i18next';
import ContainerValidation from "../../Dashboard/Visitor/External/Components/ContainerValidation";
import HeaderValidation from "../../Dashboard/Visitor/External/Components/HeaderValidation";
import BodyValidation from "../../Dashboard/Visitor/External/Components/BodyValidation";
import {IconIdentityApproved} from "../../../components/buttons/IconButtons";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
const BuildingRegistrationSuccessfullyVerified = () => {
    const { t } = useTranslation();

    return (
        <ContainerValidation>
            <HeaderValidation
                showBtnBack={false}
            />

            <BodyValidation
                showBtnNext={false}
                showBtnPrev={false}
            >
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("registration_already_completed")}</p>
                            <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("you_have_already_completed_your_registration_no_further_action_is_required")}</p>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center align-items-center">
                        <div className="icon-identity-validation-container">
                            <IconIdentityApproved className="w-100 h-100" />
                        </div>
                    </div>
                </>
            </BodyValidation>
        </ContainerValidation>
    )

}

export default BuildingRegistrationSuccessfullyVerified
